import { useCallback, useEffect, useRef } from "react";
const useIntelligentTimer = () => {
    const current = useRef(null);
    const end = useRef(null);
    const start = useCallback((callback, time) => {
        // If the requested time is less than the current time, do nothing
        const newEnd = Date.now() + time;
        if (end.current && newEnd < end.current)
            return;
        // If there's a timer, clear it
        if (current.current)
            clearTimeout(current.current);
        // Start the new timer
        end.current = newEnd;
        current.current = setTimeout(() => {
            callback();
            end.current = null;
        }, time);
    }, []);
    const stop = useCallback(() => {
        if (current.current)
            clearTimeout(current.current);
        end.current = null;
    }, []);
    useEffect(() => () => {
        if (current.current)
            clearTimeout(current.current);
    }, []);
    return [start, stop];
};
export default useIntelligentTimer;
